<template>
  <div class="Container">
    <b-container>
      <div class="mainDiv">
        <div>
          <span>
            <a href="Reports" class="returnLink"> Return to Reports </a>
          </span>
          <div class="deviceDetails">
            <h1 class="pageHeader">Historic Device Detail Report</h1>

            <b-row class="deviceInfo">
              <b-col sm="4">
                <p class="headerText">
                  Device:
                  <span class="dataText"> <br />{{ this.DeviceID }}</span>
                </p>
              </b-col>
              <b-col sm="4">
                <p class="headerText">
                  Location:
                  <span class="dataText"> <br />{{ this.Location }} </span>
                </p>
              </b-col>
              <b-col sm="4">
                <p class="headerText">
                  Position:
                  <span class="dataText"> <br />{{ this.Position }} </span>
                </p>
              </b-col>
            </b-row>
          </div>
          <div class="filterBox">
            <b-row>
              <p id="Selector">Select Date Range to Filter by</p>
            </b-row>
            <b-row>
              <b-col
                ><p id="Selector">
                  From Date: <br />
                  <b-form-datepicker
                    type="date"
                    :min="min"
                    :max="max"
                    v-model="FromDate"
                    @focus="modal = false"
                  />
                </p>
              </b-col>
              <b-col
                ><p id="Selector">
                  To Date: <br />
                  <b-form-datepicker
                    type="date"
                    :min="min"
                    :max="max"
                    v-model="ToDate"
                    @focus="modal = false"
                  />
                </p>
              </b-col>
            </b-row>
            <b-row class="SubmitRow">
              <b-col>
                <p id="Selector">
                  <button class="button" v-on:click="DynamicSelect()">
                    Submit
                  </button>
                  <button class="button" v-on:click="resetValue()">
                    Clear
                  </button>
                </p>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-row style="display:flex;">
          <b-col style="padding-bottom:1%;" class="col-4">
            <div class="chartBox">
              <DeviceReportChart
                :chartData="this.setChartData()"
                :options="this.setChartOptions1()"
              >
              </DeviceReportChart>
            </div>
          </b-col>
          <b-col style="padding-bottom:1%;" class="col-4">
            <div class="chartBox">
              <BiofilmChart
                :chartData="this.setChartData2()"
                :options="this.setChartOptions2()"
              >
              </BiofilmChart>
            </div>
          </b-col>
          <b-col style="padding-bottom:1%;" class="col-4">
            <div class="chartBox">
              <TempChart
                :chartData="this.setChartData3()"
                :options="this.setChartOptions3()"
              >
              </TempChart>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>

    <div v-if="ProfilePortal != 'CEU'">
      <div id="Data">
        <b-row id="ButtonRow">
          <b-col>
            <p id="Selector">
              <b-button v-b-toggle.collapse-3 class="button"
                >Show/Hide Readings</b-button
              >
            </p>
          </b-col>
        </b-row>
        <b-collapse id="collapse-3">
          <b-row>
            <b-col><h5 id="MiddleSector">Select readings for table</h5> </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-row> <p id="Selector">Temperature:</p> </b-row>
              <b-row>
                <select v-model="TempShow">
                  <option value="true">Include</option>
                  <option value="false">Exclude</option>
                </select>
              </b-row>
            </b-col>
            <b-col>
              <b-row> <p id="Selector">Flow:</p> </b-row>
              <b-row>
                <select v-model="FlowShow">
                  <option value="true">Include</option>
                  <option value="false">Exclude</option>
                </select>
              </b-row>
            </b-col>
            <b-col>
              <b-row> <p id="Selector">Biofilm:</p> </b-row>
              <b-row>
                <select v-model="BioShow">
                  <option value="true">Include</option>
                  <option value="false">Exclude</option>
                </select>
              </b-row>
            </b-col>
          </b-row>

          <div class="DataContainer">
            {{ this.TempShow["2021-12-07"] }}

            <div
              v-if="
                (TempShow == 'true') &
                  (FlowShow == 'true') &
                  (BioShow == 'true')
              "
            >
              <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                <h2 class="pageHeader">{{ date }}</h2>

                <div v-if="TempTable[date] != ''">
                  <h5>Temperature</h5>

                  <table class="table table-bordered ">
                    <thead>
                      <tr>
                        <th id="Temp">Time</th>
                        <th id="Temp">Min Temp</th>
                        <th id="Temp">Max Temp</th>
                        <th id="Temp">Med Temp</th>
                        <th id="Temp">Temp Alert Level</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in TempTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="TempTable[date] == ''">
                  <h4 id="Temp">Temp</h4>
                  <p class="Centre">No Data Found</p>
                </div>

                <div v-if="FlowTable[date] != ''">
                  <h5>Flow</h5>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="Flow">Time</th>
                        <th id="Flow">Flow Occurrences</th>
                        <th id="Flow">No. Of Flow Events</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in FlowTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="FlowTable[date] == ''">
                  <h4 id="Flow">Flow</h4>
                  <p class="Centre">No Data Found</p>
                </div>

                <div v-if="BioTable[date] != ''">
                  <h5>Biofilm Level</h5>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="Bio">Time</th>
                        <th id="Bio">Biofilm Level (1-5)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in BioTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="BioTable[date] == ''">
                  <h4 id="Bio">Biofilm Level</h4>
                  <p class="Centre">No Data Found</p>
                </div>
              </div>
            </div>

            <div
              v-if="
                (TempShow == 'false') &
                  (FlowShow == 'true') &
                  (BioShow == 'true')
              "
            >
              <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                <h2 class="pageHeader">{{ date }}</h2>

                <div v-if="FlowTable[date] != ''">
                  <h5>Flow</h5>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="Flow">Time</th>
                        <th id="Flow">Flow Occurrences</th>
                        <th id="Flow">No. Of Flow Events</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in FlowTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="FlowTable[date] == ''">
                  <h4 id="Flow">Flow</h4>
                  <p class="Centre">No Data Found</p>
                </div>

                <div v-if="BioTable[date] != ''">
                  <h5>Biofilm Level</h5>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="Bio">Time</th>
                        <th id="Bio">Biofilm Level (1-5)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in BioTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="BioTable[date] == ''">
                  <h4 id="Bio">Biofilm Level</h4>
                  <p class="Centre">No Data Found</p>
                </div>
              </div>
            </div>

            <div
              v-if="
                (TempShow == 'false') &
                  (FlowShow == 'false') &
                  (BioShow == 'true')
              "
            >
              <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                <h2 class="pageHeader">{{ date }}</h2>

                <div v-if="BioTable[date] != ''">
                  <h5>Biofilm Level</h5>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="Bio">Time</th>
                        <th id="Bio">Biofilm Level (1-5)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in BioTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="BioTable[date] == ''">
                  <h5>Biofilm Level</h5>
                  <p class="Centre">No Data Found</p>
                </div>
              </div>
            </div>

            <div
              v-if="
                (TempShow == 'false') &
                  (FlowShow == 'true') &
                  (BioShow == 'false')
              "
            >
              <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                <h2 class="pageHeader">{{ date }}</h2>

                <div v-if="FlowTable[date] != ''">
                  <h5>Flow</h5>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="Flow">Time</th>
                        <th id="Flow">Flow Occurrences</th>
                        <th id="Flow">No. Of Flow Events</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in FlowTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="FlowTable[date] == ''">
                  <h4 id="Flow">Flow</h4>
                  <p class="Centre">No Data Found</p>
                </div>
              </div>
            </div>

            <div
              v-if="
                (TempShow == 'true') &
                  (FlowShow == 'false') &
                  (BioShow == 'false')
              "
            >
              <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                <h2 class="pageHeader">{{ date }}</h2>
                <div v-if="TempTable[date] != ''">
                  <h5>Temperature</h5>

                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="Temp">Time</th>
                        <th id="Temp">Min Temp</th>
                        <th id="Temp">Max Temp</th>
                        <th id="Temp">Med Temp</th>
                        <th id="Temp">Temp Alert Level</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in TempTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="TempTable[date] == ''">
                  <h4 id="Temp">Temp</h4>
                  <p class="Centre">No Data Found</p>
                </div>
              </div>
            </div>

            <div
              v-if="
                (TempShow == 'true') &
                  (FlowShow == 'true') &
                  (BioShow == 'false')
              "
            >
              <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                <h2 class="pageHeader">{{ date }}</h2>
                <div v-if="TempTable[date] != ''">
                  <h5>Temperature</h5>

                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="Temp">Time</th>
                        <th id="Temp">Min Temp</th>
                        <th id="Temp">Max Temp</th>
                        <th id="Temp">Med Temp</th>
                        <th id="Temp">Temp Alert Level</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in TempTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="TempTable[date] == ''">
                  <h4 id="Temp">Temp</h4>
                  <p class="Centre">No Data Found</p>
                </div>

                <div v-if="FlowTable[date] != ''">
                  <h5>Flow</h5>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="Flow">Time</th>
                        <th id="Flow">Flow Occurrences</th>
                        <th id="Flow">No. Of Flow Events</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in FlowTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="FlowTable[date] == ''">
                  <h4 id="Flow">Flow</h4>
                  <p class="Centre">No Data Found</p>
                </div>
              </div>
            </div>

            <div
              v-if="
                (TempShow == 'true') &
                  (FlowShow == 'false') &
                  (BioShow == 'true')
              "
            >
              <div v-for="(date, idx) in LabelDatesArray" :key="idx">
                <h2 class="pageHeader">{{ date }}</h2>
                <div v-if="TempTable[date] != ''">
                  <h5>Temperature</h5>

                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="Temp">Time</th>
                        <th id="Temp">Min Temp</th>
                        <th id="Temp">Max Temp</th>
                        <th id="Temp">Med Temp</th>
                        <th id="Temp">Temp Alert Level</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in TempTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="TempTable[date] == ''">
                  <h4 id="Temp">Temp</h4>
                  <p class="Centre">No Data Found</p>
                </div>

                <div v-if="BioTable[date] != ''">
                  <h4>Biofilm Level</h4>
                  <table class="table table-bordered">
                    <thead>
                      <tr>
                        <th id="Bio">Time</th>
                        <th id="Bio">Biofilm Level (1-5)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(date, idx) in BioTable[date]" :key="idx">
                        <td v-for="(item, idx) in date" :key="idx">
                          {{ item }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="BioTable[date] == ''">
                  <h4 id="Bio">Biofilm Level</h4>
                  <p class="Centre">No Data Found</p>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import DeviceReportChart from "../components/DeviceFlowChart.vue";
import BiofilmChart from "../components/DeviceBioFilmChart.vue";
import TempChart from "../components/DeviceTempChart.vue";

export default {
  components: {
    DeviceReportChart,
    BiofilmChart,
    TempChart,
  },

  computed: {
    rows() {
      return this.items.length;
    },
  },
  data() {
    return {
      DeviceID: "",
      FromDate: "",
      ToDate: "",
      modal: false,
      CounterVal: null,
      ReportError: "False",
      TodayDate: "",
      TodayTime: "",
      LabelDates: "",
      LabelDatesArray: [],
      responseArray: [],
      TempArray: [],
      GraphArray: [],
      FlowArray: [],
      BioArray: [],
      DateArray: [],
      TableArray: [],
      TableData: [],
      TempData: [],
      Dates: "",
      TempTable: {},
      FlowTable: {},
      BioTable: {},
      Position: "",
      Location: "",
      hover: false,
      TempShow: "true",
      BioShow: "true",
      FlowShow: "true",
      ProfilePortal: localStorage.getItem("profileportal"),
      Score: "",
      HistoryStartDate: "",
      HistoryStartTime: "",
      HistoryEndDate: "",
      HistoryEndTime: "",
      HistoricStartBoundaryDate: "",
      HistoricEndBoundaryDate: "",
      min: "",
      max: "",
    };
  },
  mounted() {
    this.DeviceID = localStorage.getItem("PassID");
    this.Position = localStorage.getItem("DevPosition");
    this.Location = localStorage.getItem("DevLocation");

    this.HistoryStartDate = localStorage.getItem("DevStartDate");
    this.HistoryStartTime = localStorage.getItem("DevStartTime");
    this.HistoryEndDate = localStorage.getItem("DevEndDate");
    this.HistoryEndTime = localStorage.getItem("DevEndTime");

    localStorage.removeItem("PassID");
    localStorage.removeItem("DevPosition");
    localStorage.removeItem("DevLocation");
    localStorage.removeItem("DevStartDate");
    localStorage.removeItem("DevStartTime");
    localStorage.removeItem("DevEndDate");
    localStorage.removeItem("DevEndTime");

    let HistoricStartBoundaryDay = this.HistoryStartDate.slice(0, 2);
    let HistoricStartBoundaryMonth = this.HistoryStartDate.slice(3, 5);
    let HistoricStartBoundaryYear = this.HistoryStartDate.slice(6, 11);
    this.HistoricStartBoundaryDate =
      HistoricStartBoundaryYear +
      "-" +
      HistoricStartBoundaryMonth +
      "-" +
      HistoricStartBoundaryDay;

    let HistoricEndBoundaryDay = this.HistoryEndDate.slice(0, 2);
    let HistoricEndBoundaryMonth = this.HistoryEndDate.slice(3, 5);
    let HistoricEndBoundaryYear = this.HistoryEndDate.slice(6, 11);
    this.HistoricEndBoundaryDate =
      HistoricEndBoundaryYear +
      "-" +
      HistoricEndBoundaryMonth +
      "-" +
      HistoricEndBoundaryDay;

    this.TodayDate =
      HistoricEndBoundaryYear +
      "-" +
      HistoricEndBoundaryMonth +
      "-" +
      HistoricEndBoundaryDay;

    this.min = new Date(
      HistoricStartBoundaryYear,
      HistoricStartBoundaryMonth - 1,
      HistoricStartBoundaryDay
    );

    this.max = new Date(
      HistoricEndBoundaryYear,
      HistoricEndBoundaryMonth - 1,
      HistoricEndBoundaryDay
    );

    let TodayMinus1 = HistoricEndBoundaryDay - 1;

    this.ToDate = this.TodayDate;
    this.FromDate =
      HistoricEndBoundaryYear +
      "-" +
      HistoricEndBoundaryMonth +
      "-" +
      TodayMinus1;
    let LookUpURL2 =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/historicaldata";
    let LookUpHeaders2 = this.$apikeyPost;
    let LookUpData2 = {
      Report: "HistoricDetail",
      DeviceID: this.DeviceID,
      StartDate: this.HistoricStartBoundaryDate,
      StartTime: this.HistoryStartTime,
      EndDate: this.HistoricEndBoundaryDate,
      EndTime: this.HistoryEndTime,
      FromDate: this.FromDate,
      ToDate: this.ToDate,
    };

    axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
      this.Score = response.data.Device[0][2];
      (this.responseArray = []),
        (this.TempArray = []),
        (this.LabelDatesArray = response.data.Values[0]);
      this.GraphArray = response.data.Values[1];
      this.TempArray = this.GraphArray[0];
      this.FlowArray = this.GraphArray[1];
      this.BioArray = this.GraphArray[2];
      this.TableArray = response.data.Values;
      this.Dates = this.TableArray[0];
      this.TempTable = response.data.Values[2];
      this.FlowTable = response.data.Values[3];
      this.BioTable = response.data.Values[4];
    });
  },

  methods: {
    resetValue: function() {
      this.location = "";
      this.modal = false;
      this.FromDate = "";
      this.ToDate = "";
      this.showReport = "False";
      this.selectedReport = null;
      this.UnitID = "";
      this.CounterVal = null;
      this.ReportError = "False";

      let HistoricStartBoundaryDay = this.HistoryStartDate.slice(0, 2);
      let HistoricStartBoundaryMonth = this.HistoryStartDate.slice(3, 5);
      let HistoricStartBoundaryYear = this.HistoryStartDate.slice(6, 11);
      this.HistoricStartBoundaryDate =
        HistoricStartBoundaryYear +
        "-" +
        HistoricStartBoundaryMonth +
        "-" +
        HistoricStartBoundaryDay;

      let HistoricEndBoundaryDay = this.HistoryEndDate.slice(0, 2);
      let HistoricEndBoundaryMonth = this.HistoryEndDate.slice(3, 5);
      let HistoricEndBoundaryYear = this.HistoryEndDate.slice(6, 11);
      this.HistoricEndBoundaryDate =
        HistoricEndBoundaryYear +
        "-" +
        HistoricEndBoundaryMonth +
        "-" +
        HistoricEndBoundaryDay;

      this.TodayDate =
        HistoricEndBoundaryYear +
        "-" +
        HistoricEndBoundaryMonth +
        "-" +
        HistoricEndBoundaryDay;

      this.min = new Date(
        HistoricStartBoundaryYear,
        HistoricStartBoundaryMonth - 1,
        HistoricStartBoundaryDay
      );

      this.max = new Date(
        HistoricEndBoundaryYear,
        HistoricEndBoundaryMonth - 1,
        HistoricEndBoundaryDay
      );

      let TodayMinus1 = HistoricEndBoundaryDay - 1;

      this.ToDate = this.TodayDate;
      this.FromDate =
        HistoricEndBoundaryYear +
        "-" +
        HistoricEndBoundaryMonth +
        "-" +
        TodayMinus1;
      let LookUpURL2 =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/historicaldata";
      let LookUpHeaders2 = this.$apikeyPost;
      let LookUpData2 = {
        Report: "HistoricDetail",
        DeviceID: this.DeviceID,
        StartDate: this.HistoricStartBoundaryDate,
        StartTime: this.HistoryStartTime,
        EndDate: this.HistoricEndBoundaryDate,
        EndTime: this.HistoryEndTime,
        FromDate: this.FromDate,
        ToDate: this.ToDate,
      };

      axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
        (this.responseArray = []),
          (this.TempArray = []),
          (this.LabelDatesArray = response.data.Values[0]);
        this.GraphArray = response.data.Values[1];

        this.TempArray = this.GraphArray[0];
        this.FlowArray = this.GraphArray[1];
        this.BioArray = this.GraphArray[2];

        this.TableArray = response.data.Values;

        this.Dates = this.TableArray[0];

        this.TempTable = response.data.Values[2];
        this.FlowTable = response.data.Values[3];
        this.BioTable = response.data.Values[4];
      });
    },

    SoftReset() {
      var date = new Date();
      date.setDate(date.getDate() - 1);

      let Yesterday =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();

      this.ToDate = this.TodayDate;
      this.FromDate = Yesterday;
    },

    DynamicSelect: function() {
      if (this.ToDate > this.TodayDate) {
        alert("Please ensure 'To Date' is not after todays date!");
        this.SoftReset();
      } else if (this.FromDate > this.ToDate) {
        alert("Please ensure 'From Date' is not after the 'To Date'!");
        this.SoftReset();
      } else {
        let HistoricStartBoundaryDay = this.HistoryStartDate.slice(0, 2);
        let HistoricStartBoundaryMonth = this.HistoryStartDate.slice(3, 5);
        let HistoricStartBoundaryYear = this.HistoryStartDate.slice(6, 11);
        this.HistoricStartBoundaryDate =
          HistoricStartBoundaryYear +
          "-" +
          HistoricStartBoundaryMonth +
          "-" +
          HistoricStartBoundaryDay;

        let HistoricEndBoundaryDay = this.HistoryEndDate.slice(0, 2);
        let HistoricEndBoundaryMonth = this.HistoryEndDate.slice(3, 5);
        let HistoricEndBoundaryYear = this.HistoryEndDate.slice(6, 11);
        this.HistoricEndBoundaryDate =
          HistoricEndBoundaryYear +
          "-" +
          HistoricEndBoundaryMonth +
          "-" +
          HistoricEndBoundaryDay;

        this.TodayDate =
          HistoricEndBoundaryYear +
          "-" +
          HistoricEndBoundaryMonth +
          "-" +
          HistoricEndBoundaryDay;

        this.min = new Date(
          HistoricStartBoundaryYear,
          HistoricStartBoundaryMonth - 1,
          HistoricStartBoundaryDay
        );

        this.max = new Date(
          HistoricEndBoundaryYear,
          HistoricEndBoundaryMonth - 1,
          HistoricEndBoundaryDay
        );

        let LookUpURL2 =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/historicaldata";
        let LookUpHeaders2 = this.$apikeyPost;
        let LookUpData2 = {
          Report: "HistoricDetail",
          DeviceID: this.DeviceID,
          StartDate: this.HistoricStartBoundaryDate,
          StartTime: this.HistoryStartTime,
          EndDate: this.HistoricEndBoundaryDate,
          EndTime: this.HistoryEndTime,
          FromDate: this.FromDate,
          ToDate: this.ToDate,
        };

        axios.post(LookUpURL2, LookUpData2, LookUpHeaders2).then((response) => {
          (this.responseArray = []),
            (this.TempArray = []),
            (this.LabelDatesArray = response.data.Values[0]);
          this.GraphArray = response.data.Values[1];

          this.TempArray = this.GraphArray[0];
          this.FlowArray = this.GraphArray[1];
          this.BioArray = this.GraphArray[2];

          this.TableArray = response.data.Values;

          this.Dates = this.TableArray[0];

          this.TempTable = response.data.Values[2];
          this.FlowTable = response.data.Values[3];
          this.BioTable = response.data.Values[4];
        });
      }
    },
    setChartData() {
      return {
        labels: this.LabelDatesArray,
        datasets: [
          {
            label: "No of Flow Events",
            backgroundColor: "rgb(125, 125, 255)",
            data: this.FlowArray,
          },
        ],
      };
    },

    setChartData2() {
      return {
        labels: this.LabelDatesArray,
        datasets: [
          {
            label: "Biofilm Level (1-5)",
            fill: false,
            borderColor: "rgb(125, 255, 125)",
            spanGaps: true,
            tension: 0.25,
            data: this.BioArray,
          },
        ],
      };
    },

    setChartData3() {
      return {
        labels: this.LabelDatesArray,
        datasets: [
          {
            label: "Temperature (C)",
            fill: false,
            borderColor: "rgb(255, 125, 125)",
            spanGaps: true,
            tension: 0.25,
            data: this.TempArray,
          },
        ],
      };
    },
    setChartOptions1() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "#000000",
                beginAtZero: true,
                suggestedMin: 0,
              },
            },
          ],
          xAxes: [{ ticks: { fontColor: "#000000", beginAtZero: true } }],
        },
        legend: { labels: { fontColor: "#000000" } },
      };
    },

    setChartOptions2() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "#000000",
                beginAtZero: false,
                suggestedMin: 1,
                suggestedMax: 5,
              },
            },
          ],
          xAxes: [{ ticks: { fontColor: "#000000", beginAtZero: true } }],
        },
        legend: { labels: { fontColor: "#000000" } },
      };
    },
    setChartOptions3() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: "#000000",
                beginAtZero: true,
                suggestedMin: 0,
              },
            },
          ],
          xAxes: [{ ticks: { fontColor: "#000000", beginAtZero: true } }],
        },
        legend: { labels: { fontColor: "#000000" } },
      };
    },
  },
};
</script>

<style scyAxed>
select:focus {
  min-width: 15%;
  width: auto;
}

input[type="text"] {
  width: 80%;
  margin: 0px 0;
  padding: 2px 8px;
  position: relative;
}

table tr {
  background-color: #f2f2f2;
  color: black;
  text-align: center;
  font-size: small;
}

#LeftChart {
  padding-left: 2.5%;
  width: 30%;
  float: left;
}
#CentreChart {
  width: 30%;
  float: left;
  padding-left: 5%;
}

#RightChart {
  width: 30%;
  float: left;
  padding-left: 5%;
}

#Flow {
  background-color: rgb(187, 187, 187);
  color: #444444;
}

#Temp {
  background-color: rgb(187, 187, 187);
  color: #444444;
}

#Bio {
  background-color: rgb(187, 187, 187);
  color: #444444;
}
#DataDump {
  border-top: solid 2px blue;
}
#Selector {
  text-align: center;
  width: 100%;
  padding-top: 10px;
  margin: 0;
  font-weight: 400;
}

select {
  width: 34%;
  padding: 10px 10px;
  border: solid;

  background-color: #f4f6f6;
  color: black;
  font-size: 11pt;
  margin-right: 33%;
  border-width: 1px;
  margin-left: 33%;
}

.button {
  text-align: center;
}
#ButtonRow {
  padding-top: 25px;
}

.mainDiv {
  padding: 1rem;
}
.chartBox {
  border: solid 1px rgb(180, 180, 180);
  background-color: rgb(255, 255, 255);
  padding: 0.5rem;
}
.deviceDetails {
  padding-left: 3rem;
  padding-right: 3rem;
  background-color: rgba(255, 255, 255, 0);
  margin-bottom: 1rem;

  min-height: 10rem;

  border: solid 1px rgba(180, 180, 180, 0);
}
.filterBox {
  padding-left: 3rem;
  padding-right: 3rem;
  background-color: rgba(255, 255, 255, 0);
  margin-bottom: 1rem;

  min-height: 10rem;
}
.filterButton {
  height: 2.2rem;
  padding-right: 1.2rem;
  padding-left: 1.2rem;
  margin-top: auto;
  margin-bottom: auto;
  float: right;
  text-align: center;
  color: white;
  text-align: center;
  background-color: rgb(60, 69, 78);
  border: solid 2px rgb(70, 70, 70);
}
.pageHeader {
  text-align: center;

  font-weight: 200;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.headerText {
  font-weight: 400;
}

.dataText {
  font-weight: 600;
}
a {
  margin: 0;
  padding: 0;
}
.returnLink {
  text-align: left;
  text-decoration: underline;
  font-weight: 500;
  position: absolute;
  margin-top: 2.5%;
  padding-left: 3rem;
  margin-left: -15px;
}

.deviceInfo {
  text-align: center;
  padding-top: 1rem;
  border-bottom: solid 2px rgb(220, 220, 220);
  border-top: solid 2px rgb(220, 220, 220);
}

.DataContainer {
  padding: 1.5rem;
}

tr:nth-child(even) {
  background-color: rgba(96, 96, 96, 0.1);
}

.SubmitRow {
  padding-bottom: 20px;
}

.form-control {
  width: 100%;
}

.Container {
  text-align: left;
}
</style>
